var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"appmain",class:{ 'service-page': _vm.displayGdpr }},[_c('router-view',{key:_vm.key})],1)}
var staticRenderFns = []

export { render, staticRenderFns }